function refreshChecker($log, $interval, $window, _, layoutService, $location) {
  const intervalLengthInMs = 60000;

  const service = {};

  service.Refresh = function Refresh(search) {
    const refresh = this;

    refresh.search = search;

    refresh.stopPolling = function stopPolling() {
      if (refresh.activeInterval) {
        $interval.cancel(refresh.activeInterval);
        refresh.activeInterval = null;
      }
    };

    refresh.stop = function stop() {
      refresh.stopPolling();
      refresh.showNotifications = false;
      refresh.reloading = false;
      refresh.hash = null;
      refresh.resetGlyph();
      refresh.started = false;
    };

    refresh.reset = function reset() {
      refresh.stop();

      refresh.interval = intervalLengthInMs;
      refresh.hash = null;

      $location.search('_refresh', !refresh.interval ? 'off' : 'on');
    };

    refresh.postLoadActions = function postLoadActions(data) {
      refresh.markNewItems(data.data, data.markAsNewProperty);

      refresh.topmostNewItem = _.find(data.data, { isNew: true });

      refresh.showNotifications = false;
      refresh.resetGlyph();

      if (refresh.topmostNewItem) {
        const top = data.elementIdPrefix + refresh.topmostNewItem[data.elementIdProperty];
        const scrollPosition = layoutService.getElementTopPositionById(top);
        if (scrollPosition) {
          // Magic const of approximate double card height
          $window.scrollTo(0, Math.max(0, scrollPosition - 185));
        }
      }
    };

    refresh.reload = function reload(callback) {
      refresh.search.state.loading = true;

      refresh.notificationCallback().then(refresh.postLoadActions, () => {
        refresh.stop();
      }).finally(() => {
        refresh.search.state.loading = false;
        callback();
      });
    };

    /**
     * [markNewItems description]
     * @param  {[Array]} items           [description]
     * @param  {[String]} newPropertyName [the key used to mark new stories]
     * @return {[type]}                 [description]
     */
    refresh.markNewItems = function markNewItems(items, newPropertyName) {
      const hash = _.map(items, (current) => {
        const item = current;
        const h = refresh.createStoryHash(item, refresh.settings.matchBy);
        item.hash = h;
        return h;
      });

      let newList = [];

      if (Array.isArray(items) && refresh.hash && refresh.hash.length) {
        newList = items.slice(0, refresh.hash.length);
      }

      _.each(newList, (item) => {
        const dataItem = item;
        const matchingHash = _.find(refresh.hash, i => _.isEqual(dataItem.hash, i));

        if (!matchingHash) {
          dataItem[newPropertyName] = true;
        }

        // dataItem[newPropertyName] = !_.some(refresh.hash, function (i) {
        //   return _.isEqual(dataItem.hash, i);
        // });
      });

      refresh.hash = hash;
    };

    refresh.check = function check() {
      refresh.dataLoadCallback()
        .then((data) => {
          const { dataProperty, matchBy } = refresh.settings;
          const relevantData = dataProperty ? _.get(data, dataProperty) : data;
          const hash = _.map(relevantData, item => _.reduce(matchBy, (currentItem, prop) => {
            const hashItem = currentItem;
            hashItem[prop] = item[prop];
            return hashItem;
          }, {}));

          let relevantLength = null;

          if (refresh.interval && refresh.hash) {
            relevantLength = refresh.hash.length ? refresh.hash.length : hash.length;
          }

          if (
            refresh.interval
            && refresh.hash
            && _.differenceWith(_.take(hash, relevantLength), refresh.hash, _.isEqual).length
          ) {
            refresh.reloading = false;

            refresh.showNotifications = true;
            refresh.setGlyph();
          }

          if (!refresh.hash) {
            refresh.hash = hash;
          }

          if (!refresh.activeInterval) {
            refresh.activeInterval = $interval(refresh.check, refresh.interval);
          }
        },
        (error) => {
          $log.error('Error in refresh checker:', error);
          refresh.stop();
        });
    };

    refresh.init = function init(settings, dataLoadCallback, notificationCallback) {
      refresh.stop();

      refresh.settings = settings;
      refresh.dataLoadCallback = dataLoadCallback;
      refresh.notificationCallback = notificationCallback;
      refresh.intervalSettings = intervalLengthInMs;

      refresh.hash = null;

      refresh.interval = intervalLengthInMs;
    };

    refresh.start = function start() {
      refresh.stop();

      refresh.interval = intervalLengthInMs;

      if (refresh.interval) {
        refresh.started = true;

        refresh.check();
      }
    };

    refresh.setGlyph = function setGlyph(glyph) {
      angular.element(document.querySelector('link[rel="icon"]')).attr('href', glyph || 'favicon_new.ico');
    };

    refresh.resetGlyph = function resetGlyph() {
      refresh.setGlyph('favicon.ico');
    };

    /**
     * createHashList is a utility method to pick specific props from story objects
     * @param  {[Array]} list [list of story objects]
     * @param  {[Array]} targetProps [prop name(s) to pick from story objects]
     * @return {[Array]}      [list of key/val pairs]
     */
    refresh.createHashList = function createHashList(list, targetProps) {
      const result = list.map(item => refresh.createStoryHash(item, targetProps));

      return result;
    };

    refresh.createStoryHash = function createStoryHash(obj, targetProps) {
      return _.reduce(targetProps, (item, prop) => {
        const hashItem = item;
        hashItem[prop] = obj[prop];
        return hashItem;
      }, {});
    };
  };

  service.createRefresh = function createRefresh(search) {
    return new service.Refresh(search);
  };

  return service;
}

const arr = [
  '$log',
  '$interval',
  '$window',
  '_',
  'layoutService',
  '$location',
  refreshChecker
];

export default function (ngModule) {
  ngModule.factory('refreshChecker', arr);
}
